import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9045e49c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-item" }
const _hoisted_2 = { class: "title xag-flex-lr" }



export default /*#__PURE__*/_defineComponent({
  __name: 'record-block-wrap',
  props: {
  title: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props;

/* eslint-disable @typescript-eslint/no-unused-vars */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(__props.title), 1),
      _renderSlot(_ctx.$slots, "title-right")
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})